"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-b9be1584"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon marso-icon-wheel" }, null, -1));
const _hoisted_2 = {
    key: 0,
    class: "text-bold"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "mb-4" };
const _hoisted_5 = ["innerHTML"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const discountPopupStore_1 = require("../stores/discountPopup/discountPopupStore");
const i18n_1 = require("../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DiscountPopup',
    setup(__props) {
        const discountPopupStore = (0, discountPopupStore_1.useDiscountPopupStore)();
        const modalIsOpen = (0, vue_3.computed)(() => discountPopupStore.modalIsOpen);
        const modalIsLoading = (0, vue_3.computed)(() => discountPopupStore.modalIsLoading);
        const isNotFound = (0, vue_3.computed)(() => discountPopupStore.isNotFound);
        const discount = (0, vue_3.computed)(() => discountPopupStore.discount);
        const closeModal = () => discountPopupStore.close();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(discount) !== null)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    isOpen: (0, vue_2.unref)(modalIsOpen),
                    isLoading: (0, vue_2.unref)(modalIsLoading),
                    title: (0, vue_2.unref)(discount).title !== null
                        ? (0, vue_2.unref)(discount).title
                        : (0, vue_2.unref)(i18n_1.trans)('discount', 'Discount', 'discount_popup'),
                    onClose: _cache[0] || (_cache[0] = ($event) => (closeModal()))
                }, {
                    loading: (0, vue_2.withCtx)(() => [
                        _hoisted_1
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        ((0, vue_2.unref)(isNotFound))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("error_discount_not_found", "Error, discount not found!", "discount_popup")), 1))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("discount_expire_date", "Discount expire date", "discount_popup")) + ":", 1),
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(new Date((0, vue_2.unref)(discount).expireDate).toLocaleDateString()), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", {
                                    innerHTML: (0, vue_2.unref)(discount).description
                                }, null, 8, _hoisted_5)
                            ]))
                    ]),
                    _: 1
                }, 8, ["isOpen", "isLoading", "title"]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
